var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPlusBg = function SvgPlusBg(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#4353FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0481 13C20.512 13.0032 20.8855 13.3819 20.8823 13.8458L20.8459 19.1584L26.1585 19.1491C26.6224 19.1483 26.9992 19.5237 27 19.9876C27.0008 20.4515 26.6254 20.8283 26.1615 20.8291L20.8344 20.8384L20.7978 26.1658C20.7947 26.6297 20.416 27.0032 19.9521 27C19.4882 26.9968 19.1147 26.6181 19.1179 26.1542L19.1543 20.8414L13.8415 20.8507C13.3776 20.8515 13.0008 20.4761 13 20.0122C12.9992 19.5483 13.3746 19.1715 13.8385 19.1707L19.1658 19.1614L19.2024 13.8342C19.2055 13.3703 19.5842 12.9968 20.0481 13Z",
    fill: "white"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPlusBg, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/plus-bg.a698170d.svg";
export { ForwardRef as ReactComponent };